import React from "react";
import { Select, MenuItem, Chip, Checkbox, Input } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  chips: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    padding: "1px 0",
  },
  chip: {
    height: 16,
    fontSize: 11,
    margin: "1px 1px",
    "& .MuiChip-deleteIcon": {
      width: 14,
      height: 14,
      fontSize: 14,
      margin: "0 2px 0 -4px",
    },
  },
  menuItem: {
    fontSize: 12,
    padding: "4px 8px",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.06)" },
  },
  checkbox: {
    padding: "0 4px 0 0",
  },
  selectDisplay: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
});

interface MultiSelectChipsProps {
  value: number[];
  onChange: (ids: number[]) => void;
  options: any[];
  getOptionValue: (opt: any) => number;
  getOptionLabel: (opt: any) => string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const MultiSelectChips: React.FC<MultiSelectChipsProps> = ({
  value,
  onChange,
  options,
  getOptionValue,
  getOptionLabel,
  disabled,
  className,
  style,
}) => {
  const classes = useStyles();

  const handleDelete = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(value.filter((v) => v !== id));
  };

  const sorted = [...options].sort((a, b) =>
    getOptionLabel(a).localeCompare(getOptionLabel(b))
  );

  return (
    <Select
      multiple
      disabled={disabled}
      value={value}
      onChange={(e: any) => onChange(e.target.value)}
      input={<Input disableUnderline />}
      renderValue={(selected: any) => (
        <div className={classes.chips}>
          {sorted
            .filter((opt) => selected.includes(getOptionValue(opt)))
            .map((opt) => (
              <Chip
                key={getOptionValue(opt)}
                label={getOptionLabel(opt)}
                size="small"
                className={classes.chip}
                onMouseDown={(e) => e.stopPropagation()}
                onDelete={(e) => handleDelete(getOptionValue(opt), e)}
              />
            ))}
        </div>
      )}
      className={className}
      classes={{ select: classes.selectDisplay }}
      style={{ ...style, height: "auto", minHeight: 24 }}
      SelectDisplayProps={{ style: { padding: "2px 16px 2px 4px", minHeight: "unset" } }}
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        PaperProps: { style: { maxHeight: 300 } },
      }}
    >
      {sorted.map((opt) => (
        <MenuItem
          key={getOptionValue(opt)}
          value={getOptionValue(opt)}
          disableRipple
          className={classes.menuItem}
        >
          <Checkbox
            checked={value.includes(getOptionValue(opt))}
            size="small"
            className={classes.checkbox}
          />
          {getOptionLabel(opt)}
        </MenuItem>
      ))}
    </Select>
  );
};